import React, { Component } from "react";
import { Row, Col, Button, Modal, Typography, Form, Statistic, Tag, Spin, Divider } from 'antd';
import { PaperClipOutlined } from "@ant-design/icons"

//componentes
import CustomAvatar from "../../Widgets/Avatar/Avatar";
import { renderMontoTransaccion, tipos_facturas } from "../../Utils";


const { Text } = Typography;
const axios = require('axios').default;
const moment = require('moment');



/**
 *
 *
 * @class ModalFacturaDetalle
 * @extends {Component}
 */
class ModalFacturaDetalle extends Component {


    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            factura: {
                _id: 0,
                concepto: '',
                proyecto_id: {
                    nombre: ''
                },
                cuenta_id: {
                    nombre: ''
                },
                cuenta_destino_id: {
                    nombre: ''
                },
                monto: 0,
                fecha: new Date(),

                tipo: 0,

                usuario_id: {
                    nombre: ''
                },
                area_id: {
                    nombre: ''
                },
                rubro_id: {
                    nombre: ''
                },
                descripcion: '',
                comprobantes: [],
                actualiza_saldo: false,
                descripcion: '',

                facturas: [{
                    factura_id: {

                    },
                    monto_abonado: 0
                }],

                conceptos: []
            },
        }

    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        if(this.props.factura_id)
            this.getFactura()
    }


    /**
    * @memberof ModalTran
    * @method getFactura
    * @description Obtiene la informacion de la transacciones para el modal de detalle. Actualiza el state
    * con informacion obtenida.
    */
    getFactura = () => {
        this.setState({ loading: true })
        axios.get(`/facturas/${this.props.factura_id}`, {
            params: {
                id: this.props.factura_id
            }
        }).then(({ data }) => {
            console.log("{data}", data.data);

            this.setState({ factura: data.data });
        })
            .catch(error => {
                console.log('error', error)
            })
            .finally(() => {
                this.setState({ loading: false })
            })

    }

    render() {
        const { factura } = this.state;
        return (
            <Spin spinning={false}>
                <Form layout="vertical"   >
                    <Divider orientation="left">Información General</Divider>
                    <Row justify="center">
                        <Col span={12} >
                            <Form.Item label="Concepto" >
                                <Text type="secondary" >{factura.concepto}</Text>
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item label="Fecha" >
                                <Text type="secondary" >{moment(factura.fecha).format('YYYY-MM-DD')}</Text>
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item label="Descripción" >
                                <Text type="secondary" >{factura.descripcion}</Text>
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item label="Empresa" className="flex-left">
                                <CustomAvatar 
                                    image={axios.defaults.baseURL+"/upload/"+ factura.empresa_id?.logo}
                                    color={factura.empresa_id?.color}
                                    name={factura.empresa_id?.alias} />
                                <Text type="secondary" >{factura.empresa_id?.alias}</Text>
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item label="Proyecto" className="flex-left">
                                <CustomAvatar 
                                    image={axios.defaults.baseURL + '/upload/' + factura.proyecto_id?.logo}
                                    color={factura.proyecto_id?.color}
                                    name={factura.proyecto_id?.nombre} />
                                <Text type="secondary" >{factura.proyecto_id?.nombre}</Text>
                            </Form.Item>
                        </Col>


                    </Row>
                    <Divider orientation="left">Información Financiera</Divider>

                    <Row>

                        <Col span={12} >
                            <Form.Item label="Tipo" >
                                <Text type="secondary" >
                                    {tipos_facturas(factura.tipo)}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={12} >
                            <Form.Item label="Monto" >
                                {renderMontoTransaccion({tipo: factura.tipo, monto: factura.monto})}
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item label="Monto Restante" >
                                $ {factura.monto_restante?.toMoney(true)} MXN
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Divider />
                        <Col span={12} >
                            <Form.Item label="Autor" name="usuario_id">
                                <div>
                                    <CustomAvatar name={factura.usuario_id?.nombre ?? "N" + " " + factura.usuario_id?.apellidos ?? "A"} size="small" style={{ marginRight: '5px' }} />
                                    {factura.usuario_id?.nombre ? factura.usuario_id?.nombre + " " +factura.usuario_id?.apellidos : "N/A"}
                                </div>
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item label="Editores" name="editado_por">
                                {factura.editado_por?.map(function ({ _id, nombre, apellidos }, index) {
                                    return <div>
                                        <CustomAvatar name={`${nombre} ${apellidos}`} size="small" style={{ marginRight: '5px' }} />
                                        {`${nombre} ${apellidos}`}
                                    </div>
                                })}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Spin >

        )
    }
}



export default function (props) {
    const { visible = false, onClose = () => { } } = props
    return <Modal
        visible={visible}
        onCancel={onClose}
        title="Detalle Factura"
        closable={true}
        destroyOnClose={true}
        footer={<Button 
            onClick={onClose}
            type="primary"
        >
            Cerrar
        </Button>}
    >
        <ModalFacturaDetalle {...props} />
    </Modal>

}